<template>
  <section class="contact-us" id="contact-us">
    <div class="contact-container">
      <h2 class="contact-title fade-in-section">{{ t('home.contact.title') }}</h2>

      <el-form ref="contactForm" :model="formData" :rules="formRules" class="contact-form fade-in-section"
        @submit.prevent="handleSubmit" :hide-required-asterisk="true" label-position="top">
        <el-form-item prop="name" class="form-item" :label="t('home.contact.name')">
          <el-input v-model="formData.name" class="contact-input" size="large" />
        </el-form-item>

        <el-form-item prop="email" class="form-item" :label="t('home.contact.email')">
          <el-input v-model="formData.email" class="contact-input" size="large" />
        </el-form-item>

        <el-form-item prop="companyName" class="form-item" :label="t('home.contact.companyName')">
          <el-input v-model="formData.companyName" class="contact-input" size="large" />
        </el-form-item>

        <el-form-item prop="comment" class="form-item" :label="t('home.contact.comment')">
          <el-input v-model="formData.comment" type="textarea" :rows="4" class="contact-textarea" size="large" />
        </el-form-item>

        <el-form-item class="form-item submit-item">
          <el-button 
            type="primary" 
            class="submit-button" 
            size="large" 
            :loading="isSubmitting"
            :disabled="isSubmitting"
            @click="handleSubmit"
          >
            {{ isSubmitting ? t('home.contact.submitting') : t('home.contact.submit') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { useTranslation } from '@/utils/i18n';
import { get, post } from '@/lib/axios';
export default {
  name: 'ContactUs',
  data() {
    const { t } = useTranslation();
          return {
        t,
        isSubmitting: false,
        formData: {
          name: '',
          email: '',
          companyName: '',
          comment: ''
        },
      formRules: {
        name: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.trim() === '') {
                callback(new Error(t('home.contact.nameRequired')));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.trim() === '') {
                callback(new Error(t('home.contact.emailRequired')));
              } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                callback(new Error(t('home.contact.emailInvalid')));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        companyName: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.trim() === '') {
                callback(new Error(t('home.contact.companyNameRequired')));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        comment: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.trim() === '') {
                callback(new Error(t('home.contact.commentRequired')));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
          handleSubmit() {
        if (this.isSubmitting) return; // 防止重复提交
        
        this.$refs.contactForm.validate(async (valid) => {
          if (valid) {
            this.isSubmitting = true; // 开始提交，设置loading状态
          const body = {
            msg_type: "post",
            content: {
              post: {
                zh_cn: {
                  title: "联络我们",
                  "content": [
                    [
                      {
                        "tag": "text",
                        "text": `姓名: ${this.formData.name}\n`
                      }
                    ],
                    [
                      {
                        "tag": "text",
                        "text": `邮箱: ${this.formData.email}\n`
                      }
                    ],
                    [
                      {
                        "tag": "text",
                        "text": `公司名称: ${this.formData.companyName}\n`
                      }
                    ],
                    [
                      {
                        "tag": "text",
                        "text": `留言: ${this.formData.comment}`
                      }
                    ]
                  ]
                }
              }
            }
          }

          const apis = [
            get('https://script.google.com/macros/s/AKfycbwJGldB13U4pKbyJfl1DrLlwBPOeAcNbnUBggT8YN-LpcezyqfFXWDWHobhrb2MEk95/exec', { params: this.formData }),
            post('https://open.feishu.cn/open-apis/bot/v2/hook/229cf15e-cb97-4499-8288-9eb53407c546', body)
          ]
                                Promise.any(apis).then(res => {
             console.log(res)
             // 这里可以添加提交逻辑
             console.log('Form submitted:', this.formData)
             this.$message.success(this.t('home.contact.submitSuccess'))
             // 重置表单
             this.$refs.contactForm.resetFields()
           }).catch(err => {
             console.log(err)
             this.$message.error(this.t('home.contact.networkError'))
           }).finally(() => {
             this.isSubmitting = false; // 无论成功还是失败，都重置loading状态
           })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-us {
  padding: 60px 20px;
  background: #222;
}

.contact-container {
  max-width: 400px;
  margin: 0 auto;
}

.contact-title {
  text-align: center;
  color: #ffffff;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 50px;
  font-family: 'Aileron-Bold', sans-serif;
}

.contact-form {
  .form-item {
    margin-bottom: 25px;

    :deep(.el-form-item__label) {
      color: white;
    }

    .contact-input,
    .contact-textarea {
      :deep(.el-input__wrapper) {
        background: transparent;
        border: 2px solid #ffffff;
        border-radius: 0px;
        box-shadow: none;

      }

      :deep(.el-input__inner) {
        color: #ffffff !important;
        font-size: 16px;
        //padding: 15px 20px;
        background: transparent !important;
        caret-color: #ffffff !important;

        &::placeholder {
          color: rgba(255, 255, 255, 0.7) !important;
        }
      }
    }

    .contact-textarea {
      :deep(.el-textarea__inner) {
        color: #ffffff !important;
        font-size: 16px;
        padding: 15px 20px;
        background: transparent !important;
        border: none;
        resize: vertical;
        border: 2px solid #ffffff;
        caret-color: #ffffff !important;

        &::placeholder {
          color: rgba(255, 255, 255, 0.7) !important;
        }
      }
    }
  }

  .submit-item {
    text-align: center;
    margin-top: 40px;

    .submit-button {
      margin: 0 auto;
      background: linear-gradient(135deg, #1a7fb0 0%, #0f4c81 100%);
      border: none;
      color: #ffffff;
      font-size: 16px;
      font-weight: 600;
      padding: 12px 20px;
      border-radius: 8px;
      transition: all 0.3s ease;
      box-shadow: 0 8px 24px rgba(15, 76, 129, 0.24);

      &:hover {
        background: linear-gradient(135deg, #2196c4 0%, #125a94 100%);
        transform: translateY(-2px);
        box-shadow: 0 12px 28px rgba(15, 76, 129, 0.32);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .contact-us {
    padding: 60px 15px;
  }

  .contact-title {
    font-size: 22px;
    margin-bottom: 30px;
  }

  .contact-form {
    .form-item {
      margin-bottom: 20px;

      .contact-input,
      .contact-textarea {

        :deep(.el-input__inner),
        :deep(.el-textarea__inner) {
          padding: 12px 16px;
          font-size: 14px;
          color: #ffffff !important;
        }
      }
    }

    .submit-item {
      margin-top: 30px;

      .submit-button {
        padding: 10px 20px;
        font-size: 14px;
      }
    }
  }
}
</style>
